import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;
import Vue from 'vue'
import Page from './shop/pages/withdraw-success/withdraw-success.vue'
createPage(Page)